import { useState, useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
// import axios from "axios";
// import { NavLink } from "react-router-dom";
import Accordion from "../../components/accordion/Accordion";
import NavBar from "../../Nav Bar/NavBar";
import Button from "../../components/button/Button";
import Image from "../../assets/Overlayimage.svg";
import ColoredLogo from "../../assets/ColoredLogo.svg";
import {
  TextHeader,
  Text,
  FurtherSection,
} from "./faq.styles";

const Faq = () => {
  const [isHovered, setIsHovered] = useState(false);

  const [styles, setStyles] = useState({
    p: {
      fontFamily: "DM Sans",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "20.83px",
      textAlign: "center",
      color: "#5D5D5D",
      width: "768px",
      margin: "0 auto 48px auto",
    },

    image: {
      width: "240px",
      margin: "0 auto",
      display: "flex",
      justifyContent: "center",
      paddingBottom: "32px",
    },

    heading: {
      fontSize: "50.52px",
      fontWeight: "700",
      lineHeight: "60.6px",
      textAlign: "center",
      color: "#101828",
      marginBottom: "16px",
    },

    text: {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "20.83px",
      textAlign: "center",
      color: "#5D5D5D",
      paddingBottom: "32px",
    },

    buttonContainer: {
      display: "flex",
      justifyContent: "center",
    },

    button: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "19.01px",
      border: "1px solid #D1D1D1",
      borderRadius: "16px",
      color: "#151515",
      backgroundColor: "#EEFDFD",
      padding: "16px",
      width: "270px",
      height: "56px",
      marginBottom: "100px",
    },
  });

  // const handleScrollToTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // };

  useEffect(() => {
    const updateStyles = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 440) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          p: {
            ...prevStyles.p,
            marginBottom: "16.21px",
            width: "259.43px",
            height: "38px",
            margin: "0 auto 16.21px auto"
          },

          image: {
            ...prevStyles.image,
            width: "171px",
          },

          heading: {
            ...prevStyles.heading,
            fontSize: "32px",
            textAlign: "center",
          },

          text: {
            ...prevStyles.text,
            fontSize: "12px",
            width: "328px",
            margin: "0 auto",
          },

          button: {
            ...prevStyles.button,
            width: "208px",
            fontSize: "16px",
          },
        }));
      }
    };

    updateStyles();
    window.addEventListener("resize", updateStyles);

    return () => window.removeEventListener("resize", updateStyles);
  }, []);

  const buttonStyles = {
    ...styles.button,
    backgroundColor: isHovered ? "#F6F6F6" : "#EEFDFD",
  };

  useEffect(() => {
    AOS.init({ duration: 1500, once: false });
  }, []);

  return (
    <>
      <NavBar linkColor="#000" logo={ColoredLogo} bg="#fff" />
      <div data-aos="fade-up">
        <div>
          <TextHeader>Frequently asked questions</TextHeader>
          <Text>Everything you need to know about GiftCard8</Text>
        </div>

        <Accordion />

        <FurtherSection>
          <img src={Image} alt="Avatar group" srcSet="" style={styles.image} />
          <h3 style={styles.heading}>Still have questions?</h3>
          <p style={styles.text}>
            Can't find the answer you're looking for? Please chat the support
            team.
          </p>

          <div style={styles.buttonContainer}>
            <Button
              style={buttonStyles}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => {
                if (window.Intercom) {
                  window.Intercom("show");
                } else {
                  console.warn("Intercom is not loaded");
                }
              }}
            >
              Contact us Online
            </Button>
          </div>
        </FurtherSection>
      </div>
    </>
  );
};

export default Faq;
